export default __webpack_public_path__ + "static/10.04-d5219a4c15f539f3fbed698a286198ee.png";